import React from "react";
import { Link } from "react-router-dom";
import { OBSERVATIONS, DOMAINS } from "@/data/content";

const SELECTED = ["behavior-follows-reward", "leadership-creates-conditions", "details-reveal-values"];

export const SelectedThinking = () => {
  const items = SELECTED.map((s) => OBSERVATIONS.find((o) => o.slug === s)).filter(Boolean);

  return (
    <section data-testid="home-selected-thinking" className="bg-ink-base py-24 md:py-36 border-t border-ink-line">
      <div className="container-edge">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-xl">
            <p className="eyebrow-gold mb-5">Selected Thinking</p>
            <h2 className="display-serif text-3xl md:text-5xl text-paper-primary text-balance">
              Three that keep being borrowed.
            </h2>
          </div>
          <Link to="/thinking" className="btn-arrow" data-testid="selected-thinking-all">
            <span>The full archive</span>
            <span className="arrow">→</span>
          </Link>
        </div>

        <ol className="space-y-px bg-ink-line">
          {items.map((o, i) => {
            const d = DOMAINS.find((x) => x.slug === o.domain);
            return (
              <li key={o.slug} className="bg-ink-base">
                <Link
                  to={`/thinking/${o.slug}`}
                  data-testid={`selected-thinking-${o.slug}`}
                  className="group grid grid-cols-12 gap-6 items-baseline py-10 md:py-14 px-2 md:px-4 hover:bg-ink-surface/40 transition-colors duration-500"
                >
                  <div className="col-span-12 md:col-span-2">
                    <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-paper-mute">
                      {String(i + 1).padStart(2, "0")} · {d?.name}
                    </p>
                  </div>
                  <div className="col-span-12 md:col-span-9">
                    <h3 className="display-serif text-2xl md:text-4xl lg:text-5xl text-paper-primary group-hover:text-gold-warm transition-colors duration-300 text-balance leading-[1.05]">
                      {o.headline}
                    </h3>
                    <p className="mt-4 max-w-3xl text-paper-secondary text-base md:text-lg font-serif leading-relaxed text-pretty">
                      {o.body}
                    </p>
                  </div>
                  <div className="col-span-12 md:col-span-1 md:text-right">
                    <span className="inline-block font-mono text-[10px] uppercase tracking-[0.24em] text-paper-tertiary group-hover:text-paper-primary transition-colors duration-300">
                      Read →
                    </span>
                  </div>
                </Link>
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export default SelectedThinking;
